module.exports = __webpack_public_path__ + "001ba059ab71a699c350eb31f20c6278.svg";